import * as v from "valibot";
export function parseSchema(schema, value) {
  return v.parse(schema, value);
}
export function isSchemaError(error) {
  return v.isValiError(error);
}
export function validateField(schema, value) {
  try {
    v.parse(schema, value);
    return undefined;
  } catch (error) {
    if (v.isValiError(error)) {
      return error.issues[0]?.message;
    }
    return "Ett oväntat fel uppstod";
  }
}
export function formatSchemaError(error) {
  return error.issues.reduce((acc, issue) => {
    const key = issue.path?.[0]?.key;
    if (typeof key === "string" || typeof key === "number") {
      acc[key] = issue.message;
    }
    return acc;
  }, {});
}
export function getFieldSchema(schema, field) {
  // Object schemas wrapped in a pipe (cross-field checks) have no per-field
  // lookup, as before; only a bare object schema exposes its fields.
  if (schema.type === "object" && !("pipe" in schema) && "entries" in schema) {
    return schema.entries[field];
  }
  return undefined;
}